import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'
export default {
  async uploadLogo(params) {
    try {
      const response = await axios.post('uni/organizationProperties/uploadLogo', params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
